import { motion } from "framer-motion";
import { MaskedReveal } from "@/components/MaskedReveal";

const STEPS = [
  { n: "01", title: "Top up points", body: "Load points into your membership whenever you like. No monthly commitment, no wasted subscription." },
  { n: "02", title: "Use them anywhere", body: "Spend across F&B, desks, meeting rooms and the lounge. One balance for the whole room." },
  { n: "03", title: "Host & earn", body: "Organise events for other members and earn points back — turning community into currency." },
  { n: "04", title: "Only pay for what you use", body: "Points never force a plan on you. Your balance reflects exactly how you work." },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="bg-espresso px-6 py-24 text-cream sm:px-10 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-20 max-w-2xl">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.28em] text-oak">
            How the points work
          </span>
          <MaskedReveal
            as="h2"
            className="mt-6 font-display font-light tracking-tight text-cream"
            lineClassName="text-4xl leading-[1.02] sm:text-5xl"
            lines={["A balance, not", "a subscription."]}
          />
        </div>

        <div className="grid border-t border-cream/15 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`step-${s.n}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="flex flex-col gap-8 border-b border-cream/15 py-10 sm:border-r sm:px-8 sm:[&:nth-child(2n)]:border-r-0 lg:[&:nth-child(2n)]:border-r lg:[&:nth-child(4n)]:border-r-0 lg:first:pl-0"
            >
              <span className="font-display text-5xl font-light text-oak">{s.n}</span>
              <div>
                <h3 className="font-display text-2xl font-light tracking-tight text-cream">{s.title}</h3>
                <p className="mt-3 font-body text-sm font-light leading-relaxed text-cream/70">{s.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
